import './formPage.css';
import { useDispatch, useSelector } from 'react-redux';
import LicenseAndLanguage from '../components/serviceProviderForms/LicenseAndLanguage';
import { RootState } from 'redux/store';
import FormSideBar from '../components/common/FormSideBar/FormSideBar';
import { formCounterSlice } from '../redux/formCounter';
import Company from '../components/serviceProviderForms/Company';
import PersonInfo from '../components/serviceProviderForms/PersonInfo';
import Consultants from '../components/serviceProviderForms/Consultants';
import BankAccount from 'components/serviceProviderForms/BankAccount';
import TermsOfUse from 'components/serviceProviderForms/TermsOfUse';
// import FormNotification from 'components/common/FormNotification/FormNotification';
import { useEffect } from 'react';

function formsFactory(index: string) {
    switch (index) {
        case 'Personal Info':
            return <PersonInfo />;
        case 'License':
            return <LicenseAndLanguage />;
        case 'Company':
            return <Company />;
        case 'Additional Consultants':
            return <Consultants />;
        case 'Bank Account Details':
            return <BankAccount />;
        case 'Terms of Use':
            return <TermsOfUse />;
        default:
            return <PersonInfo />;
    }
}

const formPath = [
    'Personal Info',
    'License',
    'Company',
    'Additional Consultants',
    'Bank Account Details',
    'Terms of Use',
];

export default function FormServiceProviderPage() {
    const { screen } = useSelector((state: RootState) => state.formCounter);
    const { setNumberForms } = formCounterSlice.actions;
    const dispatch = useDispatch();
    const currentFormName = formPath[screen - 1];
    const currentForm = formsFactory(currentFormName);

    useEffect(() => {
        dispatch(setNumberForms(formPath.length));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="formPageContainer">
            {/* <FormNotification>
                {
                    isHalfMoreFilled ?
                        messageHalfWay() :
                        messageKeepFilling()
                }
            </FormNotification> */}
            <div className="formWrapper">
                <FormSideBar screen={screen} formPath={formPath} serviceProviderForms={true} />
                {currentForm}
            </div>
        </div>
    );
}
